// extracted by mini-css-extract-plugin
export default {"link":"link__FJ-ny","activeLink":"activeLink__qSkyL"};